import { Redirect, Route } from 'react-router-dom';

import PropTypes from 'prop-types';

import EmptyPage from 'pages/EmptyPage';

import { useSelector } from 'store/utils';

const PrivateRoute = ({ component: WrappedComponent, allowingPermission, urlByPermissions, ...routeProps }) => {
    const { isLoadUser, permissions } = useSelector((state) => state.user);

    if (isLoadUser) {
        return <EmptyPage />;
    }

    return (
        <Route
            {...routeProps}
            render={(props) =>
                permissions.includes(allowingPermission) ? (
                    <WrappedComponent {...props} />
                ) : (
                    <Redirect to={urlByPermissions(permissions)} />
                )
            }
        />
    );
};

PrivateRoute.propTypes = {
    component: PropTypes.elementType,
    allowingPermission: PropTypes.string,
    urlByPermissions: PropTypes.func,
};

export default PrivateRoute;
